import React from 'react';
import { AnimateOnScroll } from '../AnimateOnScroll';
export function BBLWhyWeLove() {
  return <section className="bg-[#ECECEC] py-[60px] lg:py-[100px]" data-id="element-288">
      <div className="max-w-[800px] mx-auto px-6 lg:px-8" data-id="element-289">
        <AnimateOnScroll className="text-center flex flex-col items-center" data-id="element-290">
          <h2 className="text-[26px] lg:text-[40px] uppercase text-black leading-tight mb-6 font-[600] font-[Poppins,_sans-serif]" data-id="element-291">
            WHY WE LOVE BBL
          </h2>

          <div className="w-[40px] h-[2px] bg-[#FF1493] mb-8" data-id="element-292"></div>

          <p className="text-black text-lg leading-[1.8] font-body mb-12" data-id="element-293">
            A new study published in the Journal of Investigative Dermatology
            indicates that Sciton BroadBand Light (BBL™) treatments can alter
            the expression of genes associated with aging, making aged skin
            resemble young skin.
          </p>

          <div className="relative max-w-[700px] mx-auto mb-12" data-id="element-294">
            <div className="text-[#FF1493] text-[60px] font-serif leading-none select-none opacity-60 mb-2" data-id="element-295">
              &ldquo;
            </div>
            <p className="font-serif italic text-black text-lg lg:text-[22px] leading-[1.6]" data-id="element-296">
              BBL treatments not only rejuvenate your skin but also reverse the
              signs of aging at a cellular level, giving you a radiant, youthful
              complexion with little to no downtime.
            </p>
          </div>

          <p className="text-[#333333] text-[17px] leading-[1.8] font-body" data-id="element-297">
            This supports the idea that BBL technology can bring functional
            changes to human skin, not just cosmetic improvements. The study
            used the FDA-cleared Sciton Joule with the BBL module and found that
            BBL treatments promote the appearance of youthful skin by modifying
            gene expression patterns in aged skin to be more like those of young
            skin.
          </p>
        </AnimateOnScroll>
      </div>
    </section>;
}